import { render } from "./fieldset.vue?vue&type=template&id=0da3f930&scoped=true"
import script from "./fieldset.vue?vue&type=script&lang=js"
export * from "./fieldset.vue?vue&type=script&lang=js"

import "./fieldset.vue?vue&type=style&index=0&id=0da3f930&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0da3f930"]])

export default __exports__